







import {
  defineComponent,
} from '@vue/composition-api';
import { useMaxQuotaText } from '@/shared/utils/getMaxQuota';

export default defineComponent({
  props: {
    /** 是否需要补充资料 */
    needSupplement: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const maxQuotaText = useMaxQuotaText();

    return {
      maxQuotaText,
    };
  },
});
